import React from "react"
import PropTypes from "prop-types"

import Col from "react-bootstrap/lib/Col"
import Row from "react-bootstrap/lib/Row"

import VenueBadges from "./VenueBadges"
import FirstSlot from "../../DeliveryInfo/FirstSlot"
import ComingSoon from "../../DeliveryInfo/ComingSoon"

import style from "./index.module.sass"

export default function VenueBox(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { venue, onClick, orderMode, isVisible = true } = props

  const {
    name,
    subtitle,
    coming_soon_at,
    first_time_slot,
    logo,
    cover_image,
    distance,
    promotion,
    accepts_cash,
    accepts_stripe,
    accepts_discount_codes,
  } = venue

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function humanDistance(distance) {
    const roundedDistance = parseFloat(distance.toFixed(1))

    if (roundedDistance < 1) {
      return ` ${roundedDistance * 1000.0} m`
    } else {
      return ` ${roundedDistance} km`
    }
  }

  function renderVenueFeatures() {
    let features = []
    if (accepts_cash) {
      features.push(I18n.t("pages.locations.venues.venue_box.payments.cash"))
    }
    if (accepts_stripe) {
      features.push(
        I18n.t("pages.locations.venues.venue_box.payments.credit_card")
      )
    }
    if (!accepts_discount_codes) {
      features.push(
        I18n.t("pages.locations.venues.venue_box.payments.no_coupon")
      )
    }

    return <div className={style.venueBoxDetails}>{features.join(" • ")}</div>
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <div
      className={style.venueCard}
      onClick={(e) => {
        onClick && onClick(e, venue)
      }}
    >
      <div className={style.coverImageContainer}>
        <div
          className={`${style.coverImage} ${
            !first_time_slot ? style.coverImageDisabled : ""
          }`}
          style={
            isVisible ? { backgroundImage: "url('" + cover_image + "')" } : {}
          }
        />
      </div>

      <div className={style.venueBoxLogo}>
        {isVisible && <img src={logo} />}
      </div>

      <div className={style.venueBoxTimeContainer}>
        <div className={style.venueBoxTime}>
          {coming_soon_at && <ComingSoon sDate={coming_soon_at} />}
          {!coming_soon_at && (
            <FirstSlot orderMode={orderMode} slot={first_time_slot} />
          )}
        </div>
      </div>

      <div className={style.venueBoxBody}>
        <VenueBadges venue={venue} />

        <h3 className={style.venueBoxName}>
          {name}
          {distance && <span className="small">{humanDistance(distance)}</span>}
        </h3>
        <div className={style.venueBoxSubtitle}>{subtitle}</div>
        <Row>
          <Col xs={12}>{renderVenueFeatures()}</Col>
        </Row>

        {promotion && (
          <Row>
            <Col xs={12}>
              <div className={style.venueBoxPromotion}>{promotion.title}</div>
            </Col>
          </Row>
        )}
      </div>
    </div>
  )
}

VenueBox.propTypes = {
  venue: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
}
